import { Component } from "@angular/core";

@Component({
  templateUrl: './healthcheck.component.html'
})
export class HealthcheckComponent {}